import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    filepond: {
      upload_visibility: true,
      visibility: false,
      is_submit_btn_disable: false,
      type: null
    },

    loading: false,
    is_submit_btn_disable: false,
    mode: '',
    language_tab: 0,
    current_language: '',
    event: {
      event_id: null,
      title: '',
      languages: [],
      flows: {},
      selected_activity_index: null
    },

    // Form checking
    form_checking_mode: false,
    required_list: [],

    // QuitEditingDialog
    quit_editing_dialog_visibility: false
  },
  mutations: {
    INIT_EVENT_DETAIL_DIALOG(state, payload) {
      state.visibility = true
      state.mode = payload.mode
      state.language_tab = 0
      state.current_language = payload.event.languages[0]
      state.event.event_id = payload.event_id
      state.event.title = payload.event.title
      state.event.languages = payload.event.languages
      state.event.flows = payload.event.flows
    },
    RESET_EVENT_DETAIL_DIALOG(state) {
      state.visibility = false
      state.mode = ''
      state.language_tab = 0
      state.current_language = ''
      state.event = {
        title: '',
        languages: [],
        flows: {},
        selected_activity_index: null
      }
    },
    INIT_EDIT_EVENT_DETAIL_DIALOG(state, payload) {
      state.visibility = true
      state.mode = payload.mode
      state.language_tab = 0
      state.current_language = ''
      state.event.title = payload.name
      state.event.languages = payload.languages
      state.event.selected_activity_index = null
    },
    INIT_CONTROL_EVENT_DETAIL_DIALOG(state, payload) {
      state.visibility = true
      state.mode = 'control'
      state.language_tab = 0
      state.current_language = ''
      state.event.selected_activity_index = null
      state.event.title = payload.title
      state.event.languages = payload.languages
      state.event.flows = payload.flows
    },

    RENAME_EVENT_DETAIL_DIALOG(state, payload) {
      state.event.title = payload.title
      state.event.languages = payload.languages

      payload.languages.forEach((language) => {
        if (!state.event.flows[language]) state.event.flows[language] = []
      })
    },
    SET_EVENT_DETAIL_DIALOG_LOADING(state, payload) {
      state.loading = payload
    },
    SET_EVENT_DETAIL_DIALOG_MODE(state, payload) {
      state.mode = payload
    },
    SET_EVENT_DETAIL_DIALOG_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    },

    SET_EVENT_DETAIL_DIALOG_LANGUAGE_TAB(state, payload) {
      state.language_tab = payload
      state.current_language = state.event.languages[payload]
    },
    SET_EVENT_DETAIL_DIALOG_SELECTED_ACTIVITY_INDEX(state, payload) {
      state.event.selected_activity_index = payload
    },
    SET_EVENT_DETAIL_DIALOG_EVENT_LANGUAGES(state, payload) {
      state.event.languages = payload
    },
    DUPLICATE_EVENT_DETAIL_DIALOG_EVENT_FLOWS(state, payload) {
      state.event.flows[payload.new_language] = JSON.parse(JSON.stringify(state.event.flows[payload.current_language]))
    },
    APPEND_EVENT_DETAIL_DIALOG_EVENT_FLOWS(state, payload) {
      let template = {}
      switch (payload) {
        case 'video':
          template = { type: 'video', data: { repeat_option: '', repeat_times: null, url: '' } }
          break
        case 'tts':
          template = { type: 'tts', data: { is_countdown: false, countdown: null, speech: '', script: '', image_url: '' } }
          break
        case 'quiz':
          template = { type: 'quiz', data: { quiz_id: null } }
          break
        case 'nlp':
          template = { type: 'nlp', data: {} }
          break
        default:
          template = { type: 'video', data: { repeat_option: '', repeat_times: null, url: '' } }
          break
      }
      state.event.flows[state.event.languages[state.language_tab]].push(template)
    },
    DELETE_EVENT_DETAIL_DIALOG_EVENT_FLOWS(state, payload) {
      state.event.flows[state.event.languages[state.language_tab]].splice(payload, 1)
    },

    // Filepond
    SET_EVENT_DETAIL_DIALOG_FILEPOND_UPLOAD_VISIBILITY(state, payload) {
      state.filepond.upload_visibility = payload
    },
    INIT_EVENT_DETAIL_DIALOG_FILEPOND(state, payload) {
      state.filepond.type = payload
      state.filepond.visibility = true
    },
    SET_EVENT_DETAIL_DIALOG_FILEPOND_VISIBILITY(state, payload) {
      state.filepond.visibility = payload
    },
    SET_EVENT_DETAIL_DIALOG_FILEPOND_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.filepond.is_submit_btn_disable = payload
    },
    SET_EVENT_DETAIL_DIALOG_FILEPOND_URLS(state, payload) {
      if (state.filepond.type === 'video') state.event.flows[state.current_language][state.event.selected_activity_index].data.url = payload[0]
      else if (state.filepond.type === 'image') state.event.flows[state.current_language][state.event.selected_activity_index].data.image_url = payload[0]
    },

    // Form checking
    SET_EVENT_DETAIL_DIALOG_FORM_CHECKING_MODE(state, payload) {
      state.form_checking_mode = payload
    },
    SET_EVENT_DETAIL_DIALOG_REQUIRED_LIST(state, payload) {
      state.required_list = payload
    },

    // QuitEditingDialog
    INIT_QUIT_EDITING_DIALOG(state) {
      state.quit_editing_dialog_visibility = true
    },
    RESET_QUIT_EDITING_DIALOG(state) {
      state.quit_editing_dialog_visibility = false
    }
  },
  actions: {
    async createEvent({ rootState, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.creating', Vuetify.locale.t('$vuetify.__EventManager.event')),
          loading: true
        })
        const device_id = rootState.auth.selected_device
        const response = await api.createEvent({ params: { device_id, title: payload.title, languages: payload.languages } })
        if (response.data.success) {
          commit('RESET_EVENT_NAMING_DIALOG')
          dispatch('fetchEventLibrary')
          dispatch('initEventDetailDialog', { mode: 'add', event_id: response.data.data.id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async initEventDetailDialog({ state, commit }, payload) {
      try {
        if (payload.mode === 'control') commit('SET_EVENT_DETAIL_DIALOG_MODE', 'control')
        if (state.mode === 'add')
          commit('SET_SNACKBAR', {
            status: true,
            color: 'loading',
            text: Vuetify.locale.t('$vuetify.__SnackBar.creating', Vuetify.locale.t('$vuetify.__EventManager.event')),
            loading: true
          })
        else
          commit('SET_SNACKBAR', {
            status: true,
            color: 'loading',
            text: Vuetify.locale.t('$vuetify.__SnackBar.loading', Vuetify.locale.t('$vuetify.__EventManager.event')),
            loading: true
          })
        const response = await api.getEvent({ event_id: payload.event_id })
        if (response.data.success) {
          const i18n_mode_text = state.mode === 'add' ? '$vuetify.__SnackBar.create' : '$vuetify.__SnackBar.load'
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t(i18n_mode_text, Vuetify.locale.t('$vuetify.__EventManager.event')),
            icon: 'check',
            timeout: '2000'
          })

          let event = JSON.parse(JSON.stringify(response.data.data))
          if (payload.mode === 'edit') {
            event.title = payload.title
            event.languages = payload.languages

            payload.languages.forEach((language) => {
              if (!event.flows[language]) event.flows[language] = []
              // Add image_url to existed tts template
              else {
                event.flows[language].forEach((activity) => {
                  if (activity.type === 'tts' && !activity.data.image_url) activity.data.image_url = ''
                })
              }
            })
          }

          commit('INIT_EVENT_DETAIL_DIALOG', { mode: payload.mode, event: event, event_id: payload.event_id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async endingEvent({ rootState, state, commit, dispatch }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.ending_event'),
          loading: true
        })
        commit('SET_EVENT_DETAIL_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device
        const response = await api.updateEvent({ params: { device_id, is_active: false }, event_id: state.event.event_id })
        if (response.data.success) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.end_event'),
            icon: 'check',
            timeout: '2000'
          })

          commit('RESET_EVENT_DETAIL_DIALOG')
          dispatch('fetchEventLibrary')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_EVENT_DETAIL_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    },

    async updateEvent({ rootState, state, commit, dispatch }, payload) {
      try {
        let required_list = []

        state.event.languages.forEach((language) => {
          state.event.flows[language].forEach((activity, activity_i) => {
            // Video
            if (activity.type === 'video') {
              if (!activity.data.repeat_option) required_list.push({ language: language, activity_i: activity_i, type: 'repeat_option' })
              else if (activity.data.repeat_option === 'repeat' && !activity.data.repeat_times && activity.data.repeat_times !== 0)
                required_list.push({ language: language, activity_i: activity_i, type: 'repeat_times' })
              if (activity.data.url === '' || activity.data.url === null) required_list.push({ language: language, activity_i: activity_i, type: 'url' })
            }
            // tts
            else if (activity.type === 'tts') {
              if (activity.data.is_countdown === true && (activity.data.countdown === null || activity.data.countdown === ''))
                required_list.push({ language: language, activity_i: activity_i, type: 'countdown' })
              if (!activity.data.script) required_list.push({ language: language, activity_i: activity_i, type: 'script' })
              if (!activity.data.speech) required_list.push({ language: language, activity_i: activity_i, type: 'speech' })
            }

            // quiz
            else if (activity.type === 'quiz') {
              if (activity.data.quiz_id === null || activity.data.quiz_id === '') required_list.push({ language: language, activity_i: activity_i, type: 'quiz' })
              else {
                const quiz_library = payload.quiz_library
                const quiz = quiz_library.find((quiz) => quiz.id === activity.data.quiz_id)
                if (!quiz.languages.some((quiz_language) => quiz_language === language)) required_list.push({ language: language, activity_i: activity_i, type: 'quiz_version' })
              }
            }
          })
        })

        commit('SET_EVENT_DETAIL_DIALOG_REQUIRED_LIST', required_list)
        if (required_list.length > 0) {
          commit('SET_SNACKBAR', {
            status: true,
            color: 'error',
            text: Vuetify.locale.t('$vuetify.__SnackBar.fields_incompleted'),
            icon: 'close',
            timeout: '2000'
          })
          await commit('SET_EVENT_DETAIL_DIALOG_FORM_CHECKING_MODE', true)
        } else {
          if (state.mode === 'add')
            commit('SET_SNACKBAR', {
              status: true,
              color: 'loading',
              text: Vuetify.locale.t('$vuetify.__SnackBar.adding', Vuetify.locale.t('$vuetify.__EventManager.event')),
              loading: true
            })
          else
            commit('SET_SNACKBAR', {
              status: true,
              color: 'loading',
              text: Vuetify.locale.t('$vuetify.__SnackBar.editing', Vuetify.locale.t('$vuetify.__EventManager.event')),
              loading: true
            })
          let flows = {}
          state.event.languages.forEach((language) => {
            if (state.event.flows[language]) {
              flows[language] = state.event.flows[language]
            }
          })

          commit('SET_EVENT_DETAIL_DIALOG_IS_SUBMIT_BTN_DISABLE', true)

          const device_id = rootState.auth.selected_device
          const response = await api.updateEvent({ params: { device_id, title: state.event.title, languages: state.event.languages, flows: flows }, event_id: state.event.event_id })
          if (response.data.success) {
            if (state.mode === 'add')
              commit('SET_SNACKBAR', {
                status: true,
                color: 'success',
                text: Vuetify.locale.t('$vuetify.__SnackBar.add', Vuetify.locale.t('$vuetify.__EventManager.event')),
                icon: 'check',
                timeout: '2000'
              })
            else
              commit('SET_SNACKBAR', {
                status: true,
                color: 'success',
                text: Vuetify.locale.t('$vuetify.__SnackBar.edit', Vuetify.locale.t('$vuetify.__EventManager.event')),
                icon: 'check',
                timeout: '2000'
              })

            commit('RESET_EVENT_DETAIL_DIALOG')
            dispatch('fetchEventLibrary')
          } else throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_EVENT_DETAIL_DIALOG_IS_SUBMIT_BTN_DISABLE', false)
      }
    },

    async uploadEventFile({ rootState, commit }, payload) {
      try {
        commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_IS_SUBMIT_BTN_DISABLE', true)
        commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_UPLOAD_VISIBILITY', false)

        const type_text = payload.type === 'video' ? Vuetify.locale.t('$vuetify.__General.video') : Vuetify.locale.t('$vuetify.__General.image')
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.uploading', type_text),
          loading: true
        })

        const device_id = rootState.auth.selected_device
        const form_data = new FormData()
        if (payload.type === 'video') form_data.append('video', payload.file)
        else if (payload.type === 'image') form_data.append('images', payload.file)
        form_data.append('device_id', device_id)

        const response = await api.uploadEventMediaFile({ params: form_data, headers: { 'Content-Type': 'multipart/form-data' } })
        if (response.data.success) {
          commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_URLS', response.data.data.urls)
          commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_VISIBILITY', false)
          commit('SET_SNACKBAR', {
            status: true,
            color: 'success',
            text: Vuetify.locale.t('$vuetify.__SnackBar.upload', type_text),
            icon: 'check',
            timeout: '2000'
          })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_IS_SUBMIT_BTN_DISABLE', false)
        commit('SET_EVENT_DETAIL_DIALOG_FILEPOND_UPLOAD_VISIBILITY', true)
      }
    }
  }
}
